import React from "react";
import { Waves, Droplets, Flame, Wind, Snowflake, LayoutGrid, Coffee, Sparkles, RotateCw, Cog, Scissors, Package } from "lucide-react";

const SERVICES = [
  { icon: Waves, title: "Pralki", desc: "Pompy, grzałki, elektrozawory, zamki." },
  { icon: Droplets, title: "Zmywarki", desc: "Pompy myjące, czyszczenie, zabudowa." },
  { icon: Flame, title: "Piekarniki", desc: "Termostaty, grzałki, programatory, szyby." },
  { icon: Wind, title: "Suszarki", desc: "Pompy spustowe, grzałki, blokady, czyszczenie." },
  { icon: Snowflake, title: "Lodówki", desc: "Sprężarki, No Frost, termostaty, udrażnianie." },
  { icon: LayoutGrid, title: "Płyty ind./ele.", desc: "Pola grzejne, szyby, regeneracja modułu." },
  { icon: Coffee, title: "Drobne AGD", desc: "Wycena po diagnostyce – ekspresy, miksery, itp." },
  { icon: Sparkles, title: "Wyparzarki", desc: "Bojlery, pompy, grzałki, termostaty." },
  { icon: RotateCw, title: "KitchenAid", desc: "Przekładnie, planetarne, regeneracje, szczotki." },
  { icon: Cog, title: "Maszynki (Wilk)", desc: "Konserwacja, silniki, przełączniki." },
  { icon: Scissors, title: "Szatkownice", desc: "Przekładnie, silniki, czujniki klapy." },
  { icon: Package, title: "Pakowarki próżniowe", desc: "Uszczelki, pompy, elektrozawory." },
];

export default function Services() {
  return (
    <section
      id="uslugi"
      data-testid="services-section"
      className="bg-zinc-50 border-t border-zinc-200 py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[var(--feniks-red)] mb-3">
              [02] Usługi
            </div>
            <h2 data-testid="services-headline" className="font-display text-3xl md:text-4xl lg:text-5xl leading-none tracking-tighter">
              Co naprawiamy.
            </h2>
          </div>
          <p className="text-zinc-600 max-w-md text-base">
            Kompleksowy serwis sprzętu domowego AGD oraz profesjonalnego sprzętu gastronomicznego.
            Diagnostyka, wymiana części, konserwacja.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-zinc-200 border border-zinc-200">
          {SERVICES.map((s, i) => (
            <div
              key={i}
              data-testid={`service-card-${i}`}
              className="bg-white p-5 md:p-7 group hover:bg-zinc-50 transition-colors relative"
            >
              <div className="absolute top-3 right-4 font-mono text-[10px] text-zinc-400">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="w-10 h-10 flex items-center justify-center border border-zinc-300 group-hover:border-[var(--feniks-red)] group-hover:text-[var(--feniks-red)] transition-colors mb-4">
                <s.icon size={18} />
              </div>
              <h3 className="font-display text-lg tracking-tight mb-1.5">{s.title}</h3>
              <p className="text-xs text-zinc-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
